import {
  hasLength as hasLengthFromTsArrayLength,
  hasMinLength as hasMinLengthFromTsArrayLength,
} from "ts-array-length";
import type { ReadonlyArrayExactLength, ReadonlyArrayMinLength } from "ts-array-length";

export { isNonEmpty } from "ts-array-length";
export type { ReadonlyArrayExactLength, ReadonlyArrayMinLength } from "ts-array-length";

type LiteralNumber<N extends number> = number extends N ? never : N;

export function hasLength<T, N extends number>(
  array: readonly T[],
  length: LiteralNumber<N>,
): array is ReadonlyArrayExactLength<T, N>;
export function hasLength<T>(array: readonly T[], length: number): boolean;
export function hasLength<T>(array: readonly T[], length: number): boolean {
  return hasLengthFromTsArrayLength(array, length);
}

export function hasMinLength<T, N extends number>(
  array: readonly T[],
  length: LiteralNumber<N>,
): array is ReadonlyArrayMinLength<T, N>;
export function hasMinLength<T>(array: readonly T[], length: number): boolean;
export function hasMinLength<T>(array: readonly T[], length: number): boolean {
  return hasMinLengthFromTsArrayLength(array, length);
}
